/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class ReturnOrder extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default ReturnOrder;


// WEBPACK FOOTER //
// ./src/routes/returnOrder/index.js